/** @format */
// For Brand New products we need to push product ID as null
import { AddToBasketProduct } from '@toucan/client/core/basket';

import { transformItemToDataLayerItem } from '@toucan/client/shared/helpers/analytics';

export type BasketProductForDataLayer = Omit<AddToBasketProduct, 'id'> & {
    id?: number;
    brand?: string;
};

/**
 * Takes a BasketProductForDataLayer and transforms to a GA4 supported Item data
 */
export function basketProductsToDataLayerItem(
    products: BasketProductForDataLayer[],
    currency?: string
) {
    return products.map((product) =>
        transformItemToDataLayerItem({
            currency: currency ?? '',
            ...product,
        })
    );
}
